import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { ClearAllRounded } from "@mui/icons-material";

const TopBar = ({ reset }) => {
  const { showResetIcon, resetSettingsHandle } = reset;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        mb: 2,
      }}
    >
      <Box sx={{ my: 1 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: "bold" }}>
          Dashboard
        </Typography>
      </Box>
      {showResetIcon && (
        <Box>
          <Tooltip title="Reset filters" placement="right">
            <IconButton onClick={resetSettingsHandle}>
              <ClearAllRounded />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default TopBar;